import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../core/navigation.service';
import { LeftPanelService } from '../../../../layout/home/services/left-panel.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../core/security/user.service';
import { DatePickerConfigService } from '../../../../shared/components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-checkup-kpi-maintenance-primary-section',
  templateUrl: './checkup-kpi-maintenance-primary-section.component.html',
  styleUrls: ['./checkup-kpi-maintenance-primary-section.component.css']
})
export class  CheckUpKpiMaintenancePrimarySectionComponent extends AbstractFormWidgetComponent {

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/control/checkup-kpi-maintenance/checkup-kpi-maintenance-primary-section/checkup-kpi-maintenance-primary-section.component.ts